function setupAccordion() {
  const isMobile = window.innerWidth <= 1023;
  const headings = document.querySelectorAll(
    ".footer-block--menu .footer-block__heading"
  );

  // Clear previous event listeners by cloning
  headings.forEach((heading) => {
    const newHeading = heading.cloneNode(true);
    heading.parentNode.replaceChild(newHeading, heading);
  });

  if (isMobile) {
    const updatedHeadings = document.querySelectorAll(
      ".footer-block--menu .footer-block__heading "
    );
    updatedHeadings.forEach((heading) => {
      heading.addEventListener("click", () => {
        const isActive = heading.classList.contains("active");

        // Remove active from all
        updatedHeadings.forEach((h) => h.classList.remove("active"));

        // Toggle current one only if it wasn't already active
        if (!isActive) {
          heading.classList.add("active");
        }
      });
    });
  } else {
    // Clean all on desktop
    headings.forEach((h) => h.classList.remove("active"));
  }
}

// Initial load
document.addEventListener("DOMContentLoaded", setupAccordion);

// On window resize
window.addEventListener("resize", setupAccordion);

document.addEventListener("DOMContentLoaded", function () {
  const customLinks = document.querySelectorAll("a.redirect-link");

  customLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault(); // prevent Shopify JS from stopping it
      e.stopPropagation(); // stop any other JS listeners
      window.location.href = link.href; // force redirect
    });
  });

  const openCartBtn = document.querySelector(".open-cart");
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (openCartBtn && cartIcon) {
    openCartBtn.addEventListener("click", function () {
      cartIcon.click(); // Trigger original cart drawer
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('.form-control');

  inputs.forEach(function(input) {
    input.addEventListener('input', function () {
      const formGroup = input.closest('.form-group');
      if (input.value.trim() !== '') {
        formGroup.classList.add('input-active');
      } else {
        formGroup.classList.remove('input-active');
      }
    });
  });
  
  // browser details
    var browserDetailFields = document.querySelectorAll("textarea.browser-details");
    var userAgent = navigator.userAgent;
    // Fill each textarea with the user agent
    browserDetailFields.forEach(function (field) {
      field.value = userAgent;
    });


  // Dynamic height for textarea
  const textareas = document.querySelectorAll('.form-control-textarea');

    textareas.forEach(function (textarea) {
      const baseHeight = 40; // CSS initial height
      const lineHeight = 24;

      // Set initial height
      textarea.style.height = baseHeight + 'px';

      textarea.addEventListener('input', function () {
        const value = textarea.value;

        if (value.trim() === '') {
          textarea.style.height = baseHeight + 'px';
          return;
        }

        // Count how many lines based on actual line breaks
        const numberOfLines = value.split('\n').length;

        // Final height = 40px + 24px * (lines - 1)
        const extraLines = Math.max(0, numberOfLines - 1);
        const newHeight = baseHeight + extraLines * lineHeight;

        textarea.style.height = newHeight + 'px';
      });
    });


function showError(field, message) {
  const formGroup = field.closest('.form-group');
  formGroup.classList.add('has-error');

  const error = document.createElement('div');
  error.className = 'error-message';
  error.textContent = message;

  // Insert after the input/textarea
  field.parentNode.appendChild(error);
}


  // Get the URL parameter "target" for contact page
    const urlParams = new URLSearchParams(window.location.search);
    const target = urlParams.get('target'); // e.g., "Website"

    // Step 1: Set the subject field from the H1 title
    const h1Title = document.querySelector('.header-contactUs-Form');
    const subjectField = document.getElementById('subject');
    if (h1Title && subjectField) {
      subjectField.value = h1Title.textContent.trim();
    }


});


// join us page dropdwn
  document.querySelector('.page-selector .custom-select').addEventListener('change', function() {
    const selectedValue = this.value;
    if (selectedValue) {
      window.location.href = selectedValue;
    }
  });